import { Controller } from '@hotwired/stimulus'
import * as basicScroll from 'basicscroll'

export default class extends Controller {
  static targets = [
    'parallax',
    'parafade'
  ]

  parallaxTargetConnected(p) {
    p.classList.add('parallax')
    let distance = 0
    if ('distance' in p.dataset) {
      distance = p.dataset.distance
    }
    let magnitude = window.innerHeight / 200
    basicScroll.create({
      elem: p,
      from: 0,
      to: 'bottom-top',
      direct: true,
      props: {
        '--translateY': {
          from: 0,
          to: `-${ magnitude * distance }px`
        }
      }
    }).start()
  }

  parafadeTargetConnected(p) {
    p.classList.add('parafade')
    basicScroll.create({
      elem: p,
      from: 'top-bottom',
      to: 'bottom-middle',
      direct: true,
      props: {
        '--opacity': {
          from: 0,
          to: 1
        }
      }
    }).start()
  }

  scrollTo(e) {
    let element = document.querySelector(e.params.element)
    let defaultLocale = document.body.dataset.defaultLocale
    let currentLocale = document.body.dataset.currentLocale
    if (element) {
      document.querySelector(e.params.element).scrollIntoView({ behavior: 'smooth' })
    } else {
      if (currentLocale != defaultLocale) {
        window.location.href = `${window.location.origin}/${currentLocale}/${e.params.element}`
      } else {
        window.location.href = `${window.location.origin}${e.params.element}`
      }
    }
  }
}
